import router from './router'
import { toastDanger } from './lib/toastCfg'

export default function (toast) {
  return (error) => {
    const code = parseInt(error.response && error.response.status)
    if (code === 422) {
      const messages = Object.keys(error.response.data.errors)
      for (let i = 0; i < messages.length; i++) {
        error.response.data.errors[messages[i]].forEach((message) => {
          toast.open(toastDanger(message))
        })
      }
    } else if (code >= 400 && code < 500) {
      if (code === 404) {
        toast.open(toastDanger(error.response.data.message))
      } else if (code === 403) {
        router.push('/')
      } else if (error.response.data.errorCode === 401000) {
        toast.open(toastDanger('Неверный логин или пароль'))
      } else if (error.response.data.errorMessage === 'Token has expired') {
        router.push('/')
        toast.open(toastDanger('Время действия токена истекло'))
      } else {
        for (let i = 0; i < error.response.data.errorMessages.length; i++) {
          toast.open(toastDanger(error.response.data.errorMessages[i]))
        }
      }
    } else if (code >= 500) {
      toast.open(toastDanger('Ошибка сервера'))
    }
  }
}
